// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"uploadViewModal_wrapper__2R3BA","dropzone":"uploadViewModal_dropzone__7wZDd","icon":"uploadViewModal_icon__LzSsE","error":"uploadViewModal_error__if0oa"};